import {
	useInvoices
} from './hooks'
import {useDispatch,useSelector} from 'react-redux'
import {setEditor,setFilterQuery} from './slice'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Invoice from './Invoice'
import Editor from './Editor'
import CenteredLoader from '../../CenteredLoader/CenteredLoader'
import useCurrentUser from '../../../hooks/useCurrentUser'
import {userIsOwner} from '../../../util/util'

const Invoices = ()=>{
	const dispatch = useDispatch()
	const user = useCurrentUser()
	const isOwner = userIsOwner(user)
	const {status,ids} = useInvoices()
	const {query} = useSelector(state=>state.invoices.filter)
	const handleCreate = ()=>{
		dispatch(setEditor({
			show:true,
			id:false
		}))
	}
	const handleSearch = (e)=>{
		dispatch(setFilterQuery(e.target.value))
	}
	if (status==='pending') return (
		<CenteredLoader/>
	)
	return (
		<>
			<div 
				style={{height:'100%',overflow:'hidden'}}
				className="d-flex flex-column pb-2" 
			>
				{isOwner&&
					<div style={{flex:'0 0 auto'}} className="d-flex align-items-end mb-2 justify-content-end">
						<Form.Control onChange={handleSearch} placeholder="Search" value={query}/>
						<Button style={{flex:'0 0 auto'}} onClick={handleCreate} variant="outline-success">
							Create Invoice
						</Button>
					</div>
				}
				<div style={{height:'100%',overflow:'hidden'}}>
					<div className="text-right mb-1">
						<small className="p-1">Qty</small>
					</div>
					<div style={{height:'100%',overflow:'auto',paddingBottom:'200px'}}>
						{ids.map( id => <Invoice id={id} /> )}
					</div>
				</div>
			</div>
			<Editor/>
		</>
	)
}

export default Invoices